import { Card } from 'primereact/card'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    padding: 0px 0px 0px 0px;
`

export const ImageContainer = styled.div`
    position: relative;
    width: 15.7rem;
    height: 11.7rem;
`

export const ImageComponent = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`

export const StyledCard = styled(Card)<{ selected?: boolean }>`
    width: 16rem;
    justify-self: flex-start;
    align-self: flex-start;
    border: ${({ selected }) => (selected ? '3px solid #ba9d31' : '3px solid transparent')};

    .p-card-body {
        display: flex;
        justify-items: center;
        margin: auto;
        flex-direction: column;
        align-items: center;
    }

    .p-card-body .p-card-title {
        margin: auto;
        font-family: 'Helvetica Neue';
        font-size: 16px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
    }
`
